// src/components/BillItemErrorBoundary.tsx
import { Component, ReactNode, ErrorInfo } from 'react';
import { Paper, Text, Group, ActionIcon } from '@mantine/core';
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react';

interface BillItemErrorBoundaryProps {
	children: ReactNode;
}

interface BillItemErrorBoundaryState {
	hasError: boolean;
}

class BillItemErrorBoundary extends Component<
	BillItemErrorBoundaryProps,
	BillItemErrorBoundaryState
> {
	constructor(props: BillItemErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): Partial<BillItemErrorBoundaryState> {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		console.error('BillItem error:', error, errorInfo);
	}

	handleReset = (): void => {
		this.setState({ hasError: false });
	};

	render(): ReactNode {
		if (this.state.hasError) {
			return (
				<Paper p='md' radius='md' withBorder>
					<Group justify='space-between'>
						<Group gap='xs'>
							<IconAlertTriangle size={20} color='#FA5252' />
							<Text size='sm' c='dimmed'>
								Failed to display bill
							</Text>
						</Group>
						<ActionIcon variant='subtle' onClick={this.handleReset}>
							<IconRefresh size={16} />
						</ActionIcon>
					</Group>
				</Paper>
			);
		}
		return this.props.children;
	}
}

export default BillItemErrorBoundary;
